import {useState,useEffect} from "react";
import { Link ,useLocation, useOutletContext, useNavigate } from "react-router-dom";
import CtntTop5InqApi from "Apis/CtntTop5InqApi";
import GameSvcCtntPstdLstInqApi from "Apis/GameSvcCtntLstInqApi";
import CommuBrdPstdLstApi from "Apis/CommuBrdPstdLstApi";
import MgpStore from "Stores/Store";
import Pagination from "react-js-pagination";
import UseLangLstQuery from "Apis/LangTxtInqApi";
import "Assets/css/Ctnt.css";
import "Assets/css/Cs.css";
import { Helmet } from "react-helmet-async";
import ApiError from "Utils/ApiError";
import GameSvcCtntLstTopFixInqApi from "Apis/GameSvcCtntLstTopFixInqApi";
import GamePageBanner from "Components/GamePageBanner";
import CommuBrdCtgrLstApi from "Apis/CommuBrdCtgrLstApi";
import CommuCategoryLayout from "Views/Commu/CommuCategoryLayout";

interface CommuBrdCtgrNode {
    ctgrCd: string;
    subCtgrCd?: string;
    ctgrNm: string;
    prntCtgrCd: string | null;
    children: CommuBrdCtgrNode[];
}

const DEFAULT_GAME_SVC_CD = "BBO";

const CommuCtntPstdLstUi = ({gameSvcCd,ctntKindCd,ctntCtgrCdName,LstType}:any) => {
    const {gameMainPageData, langData}:any = useOutletContext();
    const navigate = useNavigate();
    const location = useLocation();
    const [isMobileCategoryOpen, setIsMobileCategoryOpen] = useState(false);
    
    // const {isLoading,error,data: langData}:any = UseLangLstQuery();
    const [pageState, setPageState] = useState(1);
    const [onePageSizeState,setOnePageSizeState] = useState();
    const [totPstdCntState,setTotPstdCntState] = useState(1);
    const [ctntTypeState,setctntTypeState] = useState<string|null>();
    
    // URL 파라미터 실시간 추출 (메뉴 변경 및 페이지 변경 감지용)
    const getCurrentParams = () => {
        const currentParams = new URLSearchParams(location.search);
        return {
            currentGameSvcCd: currentParams.get("gameSvcCd") || gameSvcCd || DEFAULT_GAME_SVC_CD,
            currentCtntCtgrCd: currentParams.get("ctntKindCd") || ctntKindCd,
            currentSubCtgrCd: currentParams.get("ctntCtgrCd") || "",
            currentPage: parseInt(currentParams.get("page") || "1")
        };
    };
    
    const handlePageChange = (newPage:any) => {
        const { currentGameSvcCd, currentCtntCtgrCd } = getCurrentParams();
        
        // URL 파라미터 업데이트
        const newParams = new URLSearchParams(location.search);
        newParams.set("page", newPage.toString());
        navigate(`${location.pathname}?${newParams.toString()}`, { replace: true });
    };
    
    // 기존 파라미터 로직 (초기값 설정용)
    const serchParamsFunc = () => {
        return new URLSearchParams(location.search);
    }
    let query = serchParamsFunc();
    let getGameSvcCd = query.get("gameSvcCd");
    let getctntKindCd = query.get("ctntKindCd");
    let getctntCtgrCdName = query.get("ctntCtgrCd");
    
    if(getGameSvcCd != null){
        gameSvcCd = getGameSvcCd;
        ctntKindCd = getctntKindCd;
    }

    if(gameSvcCd == null) {
        gameSvcCd = location.state?.gameSvcCd;
    }
    if(gameSvcCd == null || gameSvcCd === "") {
        gameSvcCd = DEFAULT_GAME_SVC_CD;
    }
    if(ctntKindCd == null) {
        ctntKindCd = location.state?.ctntKindCd;
    }
    
    const [ctntCtxtState,setCtntCtxtState] = useState<any>();
    const [ctntKindCdState,setCtntKindCdState] = useState<any>();
    const [topFixCtntState,setTopFixCtntState] = useState<any>();
    const [boardCtgrTree, setBoardCtgrTree] = useState<CommuBrdCtgrNode[]>([]);
    const [expandedCategory, setExpandedCategory] = useState<string>("");
    
    useEffect(()=>{
        const { currentCtntCtgrCd, currentPage } = getCurrentParams();
        
        // 페이지 상태 동기화
        setPageState(currentPage);
        
        // 일반 게시글 목록 조회
        // CommuBrdPstdLstApi(currentGameSvcCd, currentCtntCtgrCd, currentPage, "", currentSubCtgrCd || null).then((resp)=> {
        CommuBrdPstdLstApi(currentCtntCtgrCd,getctntCtgrCdName||"")
            .then((resp)=> {
                switch(resp.apiHdr.code){
                    case "MEMB0000":
                        setCtntCtxtState(resp.apiBody.brdPstdLst);
                        setCtntKindCdState(resp.apiBody.ctntLst)
                        setPageState(resp.apiBody.nowPageNo)
                        setOnePageSizeState(resp.apiBody.onePageSize)
                        setTotPstdCntState(resp.apiBody.totCnt)
                        setTopFixCtntState(resp.apiBody.ctntTopFixLst);
                        break;
                    default:
                            ApiError(langData,resp.apiHdr.code);
                        break;
                }
            })
                .catch((err) => {
                    console.error(err);
            });
        
        // // 상단 고정 게시글 조회
        // GameSvcCtntLstTopFixInqApi(currentGameSvcCd, currentCtntCtgrCd).then((resp)=> {
        //     switch(resp.apiHdr.code){
        //         case "MEMB0000":
        //             setTopFixCtntState(resp.apiBody.ctntTopFixLst);
        //             break;
        //         default:
        //             ApiError(langData,resp.apiHdr.code);
        //             break;
        //     }
        // })
    }, [location.search, MgpStore.getState().LangSetState.Lang]); // location.search를 의존성에 추가

    useEffect(() => {
        CommuBrdCtgrLstApi()
            .then((Resp:any) => {
                if (Resp?.apiHdr?.code !== "COMM0000") {
                    ApiError(langData, Resp?.apiHdr?.code);
                    return;
                }
                setBoardCtgrTree(Resp?.apiBody?.ctgrLst || []);
            })
            .catch(() => {
                setBoardCtgrTree([]);
            });
    }, [MgpStore.getState().LangSetState.Lang]);

    useEffect(() => {
        const firstBoard = boardCtgrTree[0];
        const firstSub = firstBoard?.children?.[0];
        if (!firstBoard) return;

        const params = new URLSearchParams(location.search);
        const currentBoard = params.get("ctntKindCd");
        const currentSub = params.get("ctntCtgrCd");

        const matchedBoard = boardCtgrTree.find((item) => item.ctgrCd === currentBoard) || firstBoard;
        const matchedSub = matchedBoard.children?.find((item) => (item.subCtgrCd || item.ctgrCd) === currentSub)
            || matchedBoard.children?.[0]
            || null;

        const nextBoard = matchedBoard.ctgrCd;
        const nextSub = matchedSub ? (matchedSub.subCtgrCd || matchedSub.ctgrCd) : "";

        setExpandedCategory(nextBoard);

        const needsUpdate = currentBoard !== nextBoard || (!!nextSub && currentSub !== nextSub);
        if (needsUpdate) {
            params.set("gameSvcCd", currentParams.currentGameSvcCd);
            params.set("ctntKindCd", nextBoard);
            if (nextSub) {
                params.set("ctntCtgrCd", nextSub);
            }
            if (!params.get("page")) {
                params.set("page", "1");
            }
            navigate(`${location.pathname}?${params.toString()}`, { replace: true });
        }
    }, [boardCtgrTree, location.pathname, location.search]);

    const [ctntCtgrCdCd,setctntCtgrCdCd] = useState(ctntKindCd);
    
    // 현재 URL 파라미터를 한 번만 계산하고 저장
    const currentParams = getCurrentParams();
    
    // 모바일 카테고리 메뉴 열림 시 body 스크롤 방지
    useEffect(() => {
        if (isMobileCategoryOpen) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = '';
        }
        return () => {
            document.body.style.overflow = '';
        };
    }, [isMobileCategoryOpen]);

    const visibleMenus = boardCtgrTree.map((item) => ({
        Link: `/community/Lst?gameSvcCd=${currentParams.currentGameSvcCd}&ctntKindCd=${item.ctgrCd}&ctntCtgrCd=${item.children?.[0]?.subCtgrCd || item.children?.[0]?.ctgrCd || ""}&page=1`,
        Txt: item.ctgrNm,
        Code: item.ctgrCd,
    }));
    const selectedMenuName = visibleMenus.find((m: any) => m.Code === currentParams.currentCtntCtgrCd)?.Txt;
    const selectedBoardNode = boardCtgrTree.find((item) => item.ctgrCd === currentParams.currentCtntCtgrCd) || null;

    const handleCategorySelect = (boardCode: string) => {
        const selectedBoard = boardCtgrTree.find((item) => item.ctgrCd === boardCode);
        if (!selectedBoard) return;

        setExpandedCategory(boardCode);
        const firstSubCode = selectedBoard.children?.[0] ? (selectedBoard.children[0].subCtgrCd || selectedBoard.children[0].ctgrCd) : "";
        const newParams = new URLSearchParams(location.search);
        newParams.set("ctntKindCd", boardCode);
        if (firstSubCode) {
            newParams.set("ctntCtgrCd", firstSubCode);
        } else {
            newParams.delete("ctntCtgrCd");
        }
        newParams.set("page", "1");
        navigate(`${location.pathname}?${newParams.toString()}`, { replace: true });
    };

    const handleSubMenuSelect = (boardCode: string, subCode: string) => {
        const newParams = new URLSearchParams(location.search);
        newParams.set("ctntKindCd", boardCode);
        newParams.set("ctntCtgrCd", subCode);
        newParams.set("page", "1");
        navigate(`${location.pathname}?${newParams.toString()}`, { replace: true });
    };
    
    
    
    return(
        <>
            {/* <Helmet>
                <title></title>
            </Helmet> */}
            <div className="BgW">
            <GamePageBanner gameMainPageData={gameMainPageData} langData={langData} />
            <div className="container1580 mt30">
                <CommuCategoryLayout
                    isMobileCategoryOpen={isMobileCategoryOpen}
                    selectedCategoryLabel={selectedMenuName || "카테고리"}
                    title={(
                        <Link to="/community/Lst?gameSvcCd=BBO&ctntKindCd=PNOT" className="ctntCtgrTitlTxtLink">
                            COMMUNITY
                        </Link>
                    )}
                    categories={boardCtgrTree}
                    expandedCategory={expandedCategory}
                    activeBoardCode={currentParams.currentCtntCtgrCd}
                    activeSubCode={currentParams.currentSubCtgrCd}
                    onToggleMobileCategory={() => setIsMobileCategoryOpen(!isMobileCategoryOpen)}
                    onCloseMobileCategory={() => setIsMobileCategoryOpen(false)}
                    onCategorySelect={handleCategorySelect}
                    onSubMenuSelect={handleSubMenuSelect}
                >
                    <div className="faqCtxtLstWrap">
                            <div className="trmsContainer ctntCtgr">
                                <h1 className="ctntCtgrTitl">
                                    {selectedMenuName || ctntCtgrCdName || "COMMUNITY"}
                                </h1>
                            </div>

                            <div className="ctntLstContentsWrap">
                                {(topFixCtntState && topFixCtntState.length > 0) || (ctntCtxtState && ctntCtxtState.length > 0) ? 
                                    <>
                                    <ul className="ctntLstContentUl">
                                        {/* 상단 고정 게시글 */}
                                        {topFixCtntState && topFixCtntState.map((key:any) => (
                                            <li className="topFixCtnt" key={key.ctntSno}>
                                                <Link 
                                                    to={`/Community/CtntCtxt?gameSvcCd=${key.gameSvcCd}&ctntKindCd=${currentParams.currentCtntCtgrCd}&ctntSno=${key.ctntSno}&lang=${MgpStore.getState().LangSetState.Lang}`}
                                                    state={{ 
                                                        returnUrl: `${location.pathname}${location.search}`,
                                                        listPage: currentParams.currentPage,
                                                        listCategory: currentParams.currentCtntCtgrCd
                                                    }}
                                                >
                                                    <p className="ctntTitlTxt">
                                                        <span className="">&#x1F4CC;</span>
                                                        {key.ctntTitl}
                                                    </p>
                                                    <div className="ctntMetaInfo">
                                                        <p className="vwrCnt"><i className="eye"></i>{key.vwrCnt}</p>
                                                        <p className="ctntDate">{key.aplyStrtDtime}</p>
                                                    </div>
                                                </Link>
                                            </li>
                                        ))}
                                        {/* 일반 게시글 */}
                                        {ctntCtxtState&&ctntCtxtState.map((key:any) => (
                                            <li key={key.ctntSno}>
                                                <Link 
                                                    to={`/Community/CtntCtxt?gameSvcCd=${key.gameSvcCd}&ctntKindCd=${currentParams.currentCtntCtgrCd}&brdCtgrCd=${currentParams.currentSubCtgrCd}&ctntSno=${key.brdPstdSno}&lang=${MgpStore.getState().LangSetState.Lang}`}
                                                    state={{ 
                                                        returnUrl: `${location.pathname}${location.search}`,
                                                        listPage: currentParams.currentPage,
                                                        listCategory: currentParams.currentCtntCtgrCd
                                                    }}
                                                >
                                                    <p className="ctntTitlTxt">{key.brdPstdTitl}</p>
                                                    <div className="ctntMetaInfo">
                                                        <p className="vwrCnt"><i className="eye"></i>{key.brdPstdReadCnt}</p>
                                                        <p className="ctntDate">{key.crtdDtime}</p>
                                                    </div>
                                                </Link>
                                            </li>
                                        ))}
                                    </ul>
                                    <div className="ctntPageWrap">
                                        <Pagination
                                            activePage={currentParams.currentPage}
                                            itemsCountPerPage={onePageSizeState}
                                            totalItemsCount={totPstdCntState}
                                            pageRangeDisplayed={5}
                                            firstPageText={""}
                                            linkClassFirst={"pagenationBtn pagenationFirstBtn"}
                                            prevPageText={""}
                                            linkClassPrev={"pagenationBtn pagenationPrevBtn"}
                                            nextPageText={""}
                                            linkClassNext={"pagenationBtn pagenationNextBtn"}
                                            lastPageText={""}
                                            linkClassLast={"pagenationBtn pagenationLastBtn"}
                                            onChange={handlePageChange}
                                        />
                                    </div>
                                    </>:
                                    <><p className="noDataLi tCenter mt25">{langData&&langData.GLB_NO_DATA_LBL_00}</p></>
                                }
                                <div className="commuBtnWrap">
                                    <Link to={"/mypage"}>
                                        <p>내가 쓴 글 보기</p>
                                    </Link>
                                    <Link to={`/Community/Write`}>
                                        <p>글쓰기</p>
                                    </Link>
                                </div>
                            </div>
                    </div>
                </CommuCategoryLayout>
            </div>
        </div>
        </>
    )
}
export default CommuCtntPstdLstUi;